module.exports = __webpack_public_path__ + "static/img/introduce_9.8b4e8e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_9.png
// module id = 2Y8X
// module chunks = 1